import React, { useState, useEffect } from "react";
import { useLocation } from "react-router";
import { useDispatch } from "react-redux";
import { getPublicAssetTrackingData } from "../../redux/actions/publicAssetTracking";
import PublicAssetTrackingLargeScreen from "./Component/PublicAssetTrackingLargeScreen";
import PublicAssetTrackingSmallScreen from "./Component/PublicAssetTrackingSmallScreen";

function PublicAssetTracking() {
  /* ---------------------- Dummy Data -------------------------- */
  const dataPerPage = 5;
  const [page, setPage] = useState(0);
  const [loader, setLoader] = useState(true);
  const [assetName, setAssetName] = useState([]);
  const [todoList, setTodoList] = useState([]);
  const [ componentList, setComponentList] = useState([]);
  const [publicAssetTrackingData, setPublicAssetTrackingData] = useState();
  const [ isBooking, setIsBooking] = useState();

  const dispatch = useDispatch();

  const location = useLocation().pathname;
  const activity_assignment_id =
    location.split("/")[location.split("/").length - 1];

  // Function to call API
  const publicAsset = () => {
    const request = {
      activity_assignment_id,
      onSuccess: (data) => {
        setPublicAssetTrackingData(data[0]);
        setIsBooking(data['is_booking']);
        setLoader(false);
      },
      onError: () => {
        setLoader(false);
      },
    };
    dispatch(getPublicAssetTrackingData(request));
  };
  useEffect(() => {
    publicAsset();

    return () => {
      setPublicAssetTrackingData([])
    }
  }, []);

  // useEffect to filtered out container based to do and create new data to show asset
  useEffect(() => {
    if (publicAssetTrackingData) {
      // Filtered container based ToDos
      const assets_based_todolist =
        publicAssetTrackingData?.booking_todos?.filter(
          (element) => element.activity.based_on === "Container"
        );
      setTodoList(assets_based_todolist);
      
      if(publicAssetTrackingData.booking_todos?.length > 0){
        let sortedComponent = publicAssetTrackingData.booking_todos[0].activity?.activitycustomfields || [];
        sortedComponent = sortedComponent.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        setComponentList(sortedComponent)
      }


      if (assets_based_todolist?.length > 0) {
        // Creating Asset data from asset type and its quantity
        let listData = [];
        if (publicAssetTrackingData.asset_entries.length === 0) {
          for (const item of publicAssetTrackingData.booking_assets) {
            for (let i = 0; i < Number(item.quantity); i++) {
              listData.push({
                id: Math.random(),
                asset_type: item.asset_type?.asset_type,
                activity_assignment_id,
                asset_name: "",
              });
            }
          }
        } else {
          let assetentries = [...publicAssetTrackingData.asset_entries];
          
          listData = assetentries.map((assetItem) => {
            const obj = {
              ...assetItem,
            };
            return obj;
          });

          publicAssetTrackingData.booking_assets.forEach((element) => {
            const filteredAsset = listData.filter(
              (listItem) =>
                listItem.asset_type === element.asset_type.asset_type
            );

            const remainingAssetQuantity =
              parseInt(element.quantity) - filteredAsset.length;

            if (remainingAssetQuantity > 0) {
              for (let index = 0; index < remainingAssetQuantity; index++) {
                listData.push({
                  asset_type: element.asset_type?.asset_type,
                  asset_name: "",
                });
              }
            }
          });
        }

        // Creating New Object to store assetperformancedetails along with asset details
        const newAssetData = listData.map((assetItem) => {
          const obj = {};
          assets_based_todolist.forEach((todoItem) => {
            obj[todoItem.activity.todo_name] =
              todoItem.todo_performance_groups.length > 0
                ? todoItem.todo_performance_groups[
                    todoItem.todo_performance_groups.length - 1
                  ].todo_performances.find(
                    (assetPerformaceData) =>
                      assetPerformaceData.value ===
                      `${assetItem.asset_name}-${assetItem.asset_type}`
                  )?.date
                : "";
          });
          assetItem.assetPerformanceDetail = obj;
          return assetItem;
        });
        setAssetName([...newAssetData]);
      }
    }
  }, [publicAssetTrackingData]);

  return (
    <div className="w-full h-full overflow-y-scroll lg:overflow-y-auto bg-white scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
      <main className="bg-white min-h-screen max-h-screen overflow-y-scroll">
        <header className="bg-[#202E56] h-[60px] px-4 lg:px-8">
          <div className="w-[154px] h-full flex justify-center items-center">
            <img
              alt="Logo"
              src={require("../../assets/img/ShiperoneLogoWithName.png")}
            />
          </div>
        </header>

        {loader ? (
          <div
            className="flex justify-center items-center h-screen"
            style={{ maxHeight: "calc(100vh - 60px)" }}
          >
            <div className="block w-[100px]">
              <img
                alt="Logo"
                src={require("../../assets/img/ShiproneLogo.png")}
                className="animate-bounce"
              />
            </div>
          </div>
        ) : (
          <>
            {/* --------------------- Booking Header ------------------ */}
            <div className="px-4 lg:px-8 bg-[#F2F8FF] h-[90px] lg:h-[120px] flex items-center">
              <div className="w-full space-y-2">
                <h4 className="text-sm lg:text-lg font-semibold tracking-tight text-indigo-500">
                  Shiperone Track and Trace
                </h4>
                <h1 className="text-[#94A3B8] text-base lg:text-xl tracking-tight font-bold w-full flex items-center">
                  Booking:&nbsp;
                  <h2
                    title={publicAssetTrackingData?.internal_booking_ref_id}
                    className="text-[#1E293B] w-[90%] lg:w-full text-lg lg:text-2xl truncate"
                  >
                    {publicAssetTrackingData?.internal_booking_ref_id}
                  </h2>
                </h1>
              </div>
            </div>

            {/* ------------------- Asset Tracking --------------------- */}
            {todoList.length > 0 ? (
              <div>
                <div className="hidden md:block px-8 w-full">
                  <PublicAssetTrackingLargeScreen
                    assetName={assetName}
                    page={page}
                    dataPerPage={dataPerPage}
                    todoList={todoList}
                    componentList={componentList}
                    isBooking={isBooking}
                    setPage={setPage}
                  />
                </div>
                <div className="block md:hidden px-4 w-full">
                  <PublicAssetTrackingSmallScreen
                    assetName={assetName}
                    page={page}
                    dataPerPage={dataPerPage}
                    todoList={todoList}
                    componentList={componentList}
                    isBooking={isBooking}
                    setPage={setPage}
                  />
                </div>
              </div>
            ) : (
              <div
                className="h-screen flex justify-center items-center"
                style={{ height: "calc(100vh - 180px" }}
              >
                <div
                  className="w-2/3 h-2/3 bg-center bg-opacity-25 flex justify-center items-center space-y-2"
                  style={{
                    backgroundImage:
                      "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
                      require("../../assets/img/ShiproneLogo.png") +
                      ")",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="text-center space-y-1 text-lg font-bold text-[#1E293B] leading-5 tracking-tight">
                    <p>This Booking does not contain</p>
                    <p>any equipment based events.</p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </main>
    </div>
  );
}

export default PublicAssetTracking;
